import 'core-js/stable';
import 'regenerator-runtime/runtime';

import accordion from './modules/accordion';
import customSelect from './modules/customSelect';
import initFormModule from './modules/form';
import bookSlider from './modules/bookSlider';
import defaultSlider from './modules/defaultSlider';
import gallery from './modules/gallery';
import header from './modules/header';
import newsProductSlider from './modules/newsProductSlider';
import main from './modules/main';
import modal from './modules/modal';
import newsRelatedSlider from './modules/newsRelatedSlider';
import gallerySlider from './modules/gallerySlider';
import reviewSlider from './modules/reviewSlider';
import scrollAnimations from './modules/scrollAnimations';
import sideNav from './modules/sideNav';
import initializeNumberScaleUp from './modules/numberScaleUp';
import topLink from './modules/topLink';
import video from './modules/video';
import initA11yNavigation from './modules/a11yMenu';
import initTabSlider from './modules/tabSlider';
import deliveryAddressToggle from './block-scripts/deliveryAddressToggle';
import dynamicFields from './block-scripts/dynamicFields';

window.addEventListener('load', initA11yNavigation);
window.addEventListener('load', initializeNumberScaleUp);
window.addEventListener('load', sideNav);
window.addEventListener('load', bookSlider);
window.addEventListener('load', header);
window.addEventListener('load', accordion);
window.addEventListener('load', topLink);
window.addEventListener('load', scrollAnimations);
window.addEventListener('load', customSelect);
window.addEventListener('load', gallery);
window.addEventListener('load', video);
window.addEventListener('load', initFormModule);
window.addEventListener('load', modal);
window.addEventListener('load', defaultSlider);
window.addEventListener('load', gallerySlider);
window.addEventListener('load', reviewSlider);
window.addEventListener('load', newsRelatedSlider);
window.addEventListener('load', newsProductSlider);
window.addEventListener('load', initTabSlider);
window.addEventListener('load', deliveryAddressToggle);
window.addEventListener('load', dynamicFields);
window.addEventListener('load', main);
